import { BankStatisticLine } from "@/modules/bank/domain/BankStatisticLine";
import { BankDelivery } from "@/modules/bank/domain/BankDelivery";
import { BankStatisticScreenData } from "@/modules/bank/domain/BankStatisticScreenData";

export class VueBankStatisticScreenData implements BankStatisticScreenData{
    statistics: BankStatisticLine[];
    contracts: BankDelivery[]
    loading: boolean;
    

    constructor(){
        this.statistics = []       
        this.contracts = []   
        this.loading = false        
    }
    
    setLoading(loading){
        this.loading = loading
    }

    setStatistics(statistics_data){
        this.statistics = statistics_data
    }

    setContracts(contracts_data){
        this.contracts = contracts_data
    }

}